module.exports = "<div class=\"gw-wizard-main\">\r\n    <div class=\"gw-page gw-box\" gw-loader=\"stateTransitionPromise || true\" gw-loader-text=\"{{stateTransitionMessage | translate}}\">\r\n        <div gw-wizard-step-progress></div>\r\n        <div ng-transclude></div>\r\n    </div>\r\n    <div class=\"gw-preventActionsLayer\" ng-class=\"{'gw-locked': sidebarMenuVisible()}\"\r\n         ng-click=\"hideSidebarMenu()\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/wizard/templates/wizard-content.html
// module id = 421
// module chunks = 0